export const USER ="@USER.INFO"
export const AUTHEN ="@AUTHEN"
export const MENU ="@MENU"
export const SHORTCUTMENU ="@SHORTCUTMENU"